import { useEffect, useState } from 'react'
import OverlayLoading from 'components/atoms/OverlayLoading'
import { PUBLIC_ROLE_PLAYS_URL } from 'services/constants'
import { getRequest } from 'utils/api'
import PublicRolePlayCard from 'components/organisms/rolePlay/PublicRolePlayCard'
import PublicRolePlayHeader from 'components/organisms/rolePlay/PublicRolePlayHeader'
import colors from 'styles/colors'
import companyWebsiteTheme from 'styles/companyWebsiteTheme'
import PublicRolePlayResults from 'components/organisms/rolePlay/PublicRolePlayResults'
import PublicRolePlayFooter from 'components/organisms/rolePlay/PublicRolePlayFooter'
import PublicRolePlayLimitReached from 'components/molecules/rolePlay/PublicRolePlayLimitReached'
import { RolePlayFeedbackPopup } from 'components/organisms/rolePlay/RolePlayFeedback'
import { useSearchParams } from 'react-router-dom'

const { Box, Stack, ThemeProvider } = require('@mui/material')

const PublicRolePlay = () => {
  const [searchParams] = useSearchParams()
  const rolePlayId = searchParams.get('id')
  const [rolePlay, setRolePlay] = useState(null)
  const [loading, setLoading] = useState(false)
  const [completed, setCompleted] = useState(false)
  const [limitReached, setLimitReached] = useState(false)
  const [completedRolePlay, setCompletedRolePlay] = useState(null)
  const [started, setStarted] = useState(false)

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true)
      const res = await getRequest(
        `${PUBLIC_ROLE_PLAYS_URL}${rolePlayId ? `/${rolePlayId}` : ''}`
      )
      if (res?.status === 200) {
        setRolePlay(res.data.data)
      } else if (res?.status === 429) {
        setLimitReached(true)
      }
      setLoading(false)
    }
    fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    const targetOrigin = 'https://www.leadwithmonark.com'
    if (window.parent) {
      const data = { chatStarted: started }
      window.parent.postMessage(JSON.stringify(data), targetOrigin)
    }
  }, [started])

  useEffect(() => {
    if (completed) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    }
  }, [completed])

  return (
    <ThemeProvider theme={companyWebsiteTheme}>
      <Stack
        sx={{ backgroundColor: colors.White, overflowX: 'hidden' }}
        data-testid='all-page-content'>
        <OverlayLoading open={loading} />
        {!completed ? (
          <>
            <PublicRolePlayHeader />
            <Box
              sx={companyWebsiteTheme.publicRolePlay.container}
              style={{ paddingTop: 0 }}>
              <PublicRolePlayCard
                rolePlay={rolePlay}
                setCompleted={setCompleted}
                setCompletedRolePlay={setCompletedRolePlay}
                started={started}
                setStarted={setStarted}
              />
            </Box>
          </>
        ) : (
          <>
            <Box
              sx={{
                ...companyWebsiteTheme.publicRolePlay.container,
                overflowX: 'hidden'
              }}>
              <PublicRolePlayResults
                selectedRolePlay={rolePlay}
                selectedUserRolePlay={completedRolePlay}
              />
            </Box>
            <PublicRolePlayFooter />
          </>
        )}

        <PublicRolePlayLimitReached
          open={limitReached}
          setOpen={setLimitReached}
        />
      </Stack>
      <RolePlayFeedbackPopup />
    </ThemeProvider>
  )
}

export default PublicRolePlay
